import React, { useState, useEffect } from "react"
import { Button, Col, Form, Row, Table } from "react-bootstrap"
import { useNavigate, useParams } from "react-router-dom"
import toast from "react-hot-toast"
import Select from "react-select"
import { Select as SearchBox } from "antd"

// api
import { getAllBranches } from "../../../Helpers/apiCalls/Purchases/purchaseOrderApi"

// assets & styles
import {
  numberFormat,
  toastStyle,
  formatYDM,
  antdesignSelectStyle,
  formatDecimal,
} from "../../../Helpers/Utils/Common"
import trash from "./../../../Assets/Images/trash.png"
import Navbar from "../../../Components/Navbar/Navbar"
import { Fragment } from "react"
import { getAllSaleItemsByBranch } from "../../../Helpers/apiCalls/franchiseeApi"
import InputError from "../../../Components/InputError/InputError"
import ReactLoading from "react-loading"
import {
  getSalesQuotation,
  updateSalesQuotation,
} from "../../../Helpers/apiCalls/SalesModule/SalesQuotationApi"
import { Upload } from "antd"
import upload from "../../../Assets/Images/upload.png"
import {
  createSalesOrder,
  getSalesOrder,
  updateSalesOrder,
} from "../../../Helpers/apiCalls/SalesModule/SalesOrderApi"
import { getCustomer } from "../../../Helpers/apiCalls/Manage/CustomersApi"
import { getAllBanks } from "../../../Helpers/apiCalls/banksAPi"
import Footer from "../../../Components/Footer/Footer"
import { getAllEmployees } from "../../../Helpers/apiCalls/employeesApi"
import Modal from "antd/es/modal/Modal"
import FileExceedModal from "../../../Components/Modals/FileExceedModal"
import Compressor from "compressorjs"
import noDataImg from "../../../Assets/Images/no-data-img.png"
import { validateSalesOrder } from "../../../Helpers/Validation/Sales/SalesValidation"
import { getItemPriceByBranch } from "../../../Helpers/apiCalls/Manage/ItemPrice"

function SalesOrderForm({ add, edit }) {
  const { Dragger } = Upload
  const { id } = useParams()
  let navigate = useNavigate()
  const [inactive, setInactive] = useState(true)
  const [isChanged, setIsChanged] = useState(false)
  const [isClicked, setIsClicked] = useState(false)
  const currentDate = new Date()
  const [addDetails, setAddDetails] = useState({
    delivery_fee: 0,
    service_fee: 0,
    delivery_date: formatYDM(currentDate),
    discount: 0,
    paid_amount: 0,
    sales_date: formatYDM(currentDate),
  })
  const [orderItems, setOrderItems] = useState([])
  const [fileList, setFileList] = useState([])
  const [file, setFile] = useState([])
  const [quotations, setQuotations] = useState([])
  // DATA HANDLERS
  const [banks, setBanks] = useState([])
  const [customers, setCustomers] = useState([])
  const [branches, setBranches] = useState([])
  const [employees, setEmployees] = useState([])
  const [allItems, setAllItems] = useState([])
  const [filteredItems, setFilteredItems] = useState([])
  // const [exceed, setExceed] = useState(false);
  const [additionalItemList, setAdditionalItemList] = useState([])
  const [preview, setPreview] = useState(false)
  const [previewFile, setPreviewFile] = useState("")
  const [prevAttachments, setPrevAttachments] = useState([])
  const [showFileExceedModal, setShowFileExceedModal] = useState(false)

  console.log(addDetails)

  //ERROR HANDLING
  const [isError, setIsError] = useState({
    franchisee_id: false,
    address: false,
    delivery_date: false,
    seller_branch_id: false,
    sales_invoice_no: false,
    list: false,
    item_id: false,
    qty: false,
    qty2: false,
    invoice_no: false,
  })

  function handleSelectChange(e, type) {
    setIsChanged(true)
    if (e.name === "quotation_id") {
      e.paid_amount = 0
      e.discount_total = 0
      e.quotation_id_value = {
        name: "quotation_id",
        value_variable: "quotation_id_value",
        label: "Quote No." + e.id,
        value: e.id,
      }
      e.customer_id_value = {
        name: "customer_id",
        value_variable: "customer_id_value",
        label: e.customer_name,
        value: e.customer_id,
      }
      e.branch_id_value = {
        name: "branch_id",
        value_variable: "branch_id_value",
        label: e.branch_name,
        value: e.branch_id,
      }

      setAddDetails(e)
      var ordered_items = e.sales_quotation_items.map((item) => {
        var info = item
        info.value = item.item_id
        info.item_id = item.item_id
        info.discount_percentage = 0
        info.subtotal = item.subtotal
        info.amount = item.subtotal
        info.item_id_value = { label: item.item_name, value: item.item_id }
        info.priceValue = { label: item.price, value: item.price }
        info.unit_value = item.unit + "|" + item.item_unit_id
        info.is_old_item = true
        return info
      })
      setOrderItems(ordered_items)
      // to fetch items and set the filtered items
      // fetchItemsByBranch(e.branch_id, ordered_items, "quotation");
      fetchCustomers("set", e.customer_id)
      var _subtotal = ordered_items
        .map((item) => parseFloat(item.subtotal))
        .reduce((a, b) => a + b, 0)
      setAddDetails((prev) => {
        return {
          ...prev,
          subtotal: _subtotal.toFixed(2),
          sales_date: formatYDM(currentDate),
        }
      })
    } else {
      if (type === "customer") {
        setAddDetails((prevAddDetails) => ({
          ...prevAddDetails,
          [e.name]: e.value,
          [e.value_variable]: {
            label: e.label,
            value: e.value,
            name: e.name,
          },
          address: e.trade_address, // set trade address
          contact_no: e.phone_no, // set contact number
          vat_type: e.vat_type, // set vat
          withholding_percentage: parseInt(e.withholding_percentage), // set wht
          original_withholding_percentage: parseInt(e.withholding_percentage), // set original wht
          is_vat: e.vat_type === "VAT" ? true : false, // set vat checker
        }))
      } else {
        console.log(e.for)
        setAddDetails((prevAddDetails) => ({
          ...prevAddDetails,
          [e.name]: e.value,
          // acknowledged_by_value: {
          //   label: e.label,
          //   value: e.value,
          //   // name: e.name,
          // },
          [e.for]: e.value,
        }))
      }
    }
    setTimeout(() => setIsChanged(false), 1)
  }

  function handleAddChange(e) {
    setIsChanged(true)
    const { name, value, checked } = e.target
    if (name === "is_vat") {
      setAddDetails((prevState) => ({
        ...prevState,
        [name]: checked,
        ["vat_type"]: checked ? "VAT" : "NVAT",
        ["withholding_percentage"]: !checked
          ? 0
          : addDetails.original_withholding_percentage,
      }))
    } else if (name === "withholding_percentage") {
      setAddDetails((prevState) => ({
        ...prevState,
        ["withholding_percentage"]: value === "1" ? 1 : 2,
      }))
    } else {
      const newList = { ...addDetails }
      newList[name] = value
      setAddDetails(newList)
    }
    setTimeout(() => setIsChanged(false), 10)
  }

  /**
   *  ORDER ITEMS
   */
  function addNewOrder() {
    const newItem = {
      qty: "1",
      unit: "",
      name: "",
      item_id: "",
      priceValue: "",
      price: "0.00",
      unit_discount: "0.00",
      total: "0.00",
      subtotal: "0.00",
      amount: "0",
      discount_percentage: 0,
      discount_amount: 0,
    }
    setOrderItems((oldItems) => [...oldItems, newItem])
  }
  function deleteOrder(row) {
    setIsChanged(true)

    const updatedOrderList = [...orderItems]
    updatedOrderList.splice(row, 1)
    setOrderItems(updatedOrderList)

    const filteredOptions = allItems.filter((option) => {
      return !updatedOrderList.find((item) => item.item_id === option.item_id)
    })
    setFilteredItems(filteredOptions)

    setTimeout(() => setIsChanged(false), 10)
  }

  function handleOrderItemsChange(e, row, type) {
    setIsChanged(true)
    var temp = orderItems
    if (type === "item_id") {
      var item_name = allItems.filter((data) => {
        return data.value === e
      })
      temp[row].is_old_item = false
      temp[row].item_id = item_name[0].value
      temp[row].item_name = item_name[0].item_name
      temp[row].item_code = item_name[0].item_code
      temp[row].item_id_value = {
        label: item_name[0].label,
        value: item_name[0].value,
      }
      temp[row].qty = 1
      temp[row].unit = item_name[0].item_units[0]?.unit_from
      temp[row].item_unit_id = item_name[0].item_units[0]?.id
      temp[row].unit_value =
        item_name[0].item_units[0]?.unit_from +
        "|" +
        item_name[0].item_units[0]?.id
      temp[row].name = null
      temp[row].current_qty = item_name[0].current_qty
      temp[row].item_units = item_name[0].item_units

      const prices = []

      temp[row].has_item_price =
        item_name[0].has_item_price === 1 ? true : false
      temp[row].price =
        item_name[0].has_item_price === 1
          ? item_name[0].item_units[0]?.wholesale_price
          : 0
      temp[row].priceValue = {
        label: item_name[0].item_units[0]?.wholesale_price,
        value: item_name[0].item_units[0]?.wholesale_price,
      }
      item_name[0].item_units.map((data) => {
        if (
          data.wholesale_price !== null &&
          data.wholesale_price !== "0.0000"
        ) {
          prices.push({
            name: "price",
            label: data.wholesale_price,
            value: data.wholesale_price,
          })
        }
        if (data.retail_price !== null && data.retails_price !== "0.0000") {
          prices.push({
            name: "price",
            label: data.retail_price,
            value: data.retail_price,
          })
        }
        if (
          data.special_price_1 !== null &&
          data.special_price_1 !== "0.0000"
        ) {
          prices.push({
            name: "price",
            label: data.special_price_1,
            value: data.special_price_1,
          })
        }
        if (
          data.special_price_2 !== null &&
          data.special_price_2 !== "0.0000"
        ) {
          prices.push({
            name: "price",
            label: data.special_price_2,
            value: data.special_price_2,
          })
        }
        if (
          data.special_price_3 !== null &&
          data.special_price_3 !== "0.0000"
        ) {
          prices.push({
            name: "price",
            label: data.special_price_3,
            value: data.special_price_3,
          })
        }
        if (data.cost_price !== null && data.cost_price !== "0.0000") {
          prices.push({
            name: "price",
            label: data.cost_price,
            value: data.cost_price,
          })
        }
        // save the item prices in each item array
        temp[row].item_prices = prices
      })
      // TO FILTER ITEMS THAT ARE NOT SELECTED
      const filteredOptions = allItems.filter((option) => {
        return !temp.find((item) => item.item_id === option.item_id)
      })
      setFilteredItems(filteredOptions)
    } else if (type === "prices") {
      console.log("else if")
      console.log(e)
      // temp[row].priceValue = { label: e.label, value: e.value }
      // temp[row].price = e.value
      temp[row].priceValue = { label: e, value: e }
      temp[row].price = e
    } else {
      const { name, value } = e.target
      temp[row][name] = value
      if (name === "unit") {
        temp[row].unit = value.split("|")[0]
        temp[row].item_unit_id = value.split("|")[1]
        temp[row].unit_value = value
      }
    }
    var tempTotal = parseFloat(temp[row].qty) * parseFloat(temp[row].price)
    temp[row].subtotal = parseFloat(tempTotal)
    var tempDiscount =
      tempTotal * (parseFloat(temp[row].discount_percentage) / 100)
    temp[row].amount = tempTotal - tempDiscount
    temp[row].discount_amount = tempDiscount
    setOrderItems(temp)
    setTimeout(() => setIsChanged(false), 1)
  }

  async function handleSubmitInvoice() {
    if (validateSalesOrder(addDetails, orderItems, setIsError)) {
      setIsClicked(true)
      addDetails.status = "pending"
      addDetails.attachments = fileList
      const response = await createSalesOrder(addDetails, orderItems)

      if (response.data) {
        const salesOrderId = response.data.sales_order_id // assuming the ID is in response.data.id
        toast.success(response.data.message, {
          style: toastStyle(),
        })
        setTimeout(
          () => navigate(`/wholesaleinvoice/add/${salesOrderId}`),
          1000
        )
        // if (response.data) {
        //     toast.success(response.data.message, {
        //         style: toastStyle(),
        //     });
        //     setTimeout(() => navigate("/salesorder"), 1000);
      } else {
        response.error?.response?.data?.messages.map((data) => {
          return toast.error(data)
        })
        // setTimeout(() => refreshPage(), 1000);
      }
      setIsClicked(false)
    } else {
      toast.error(
        "Please fill in all fields and check if order quantity is greater than 0",
        { style: toastStyle() }
      )
    }
  }

  async function handleUpdatePI() {
    if (validateSalesOrder(addDetails, orderItems, setIsError)) {
      setIsClicked(true)
      addDetails.attachments = fileList
      addDetails.prev_files = prevAttachments
      const response = await updateSalesOrder(addDetails, orderItems)
      if (response.data) {
        toast.success(response.data.message, {
          style: toastStyle(),
        })
        setTimeout(() => navigate("/salesorder/print/" + id), 1000)
      } else if (response.error) {
        response.error?.response?.data?.messages.map((data) => {
          return toast.error(data)
        })
        setIsClicked(false)
      }
      setIsClicked(false)
    } else {
      toast.error(
        "Please fill in all fields and check if order quantity is greater than 0",
        { style: toastStyle() }
      )
    }
  }

  //

  const handleSubmit = () => {
    if (add) handleSubmitInvoice()
    else if (edit) handleUpdatePI()
  }

  /** FOR EDIT - Fetch Sales Invoice Details */
  async function fetchSalesOrder() {
    const response = await getSalesOrder({ id: id })
    if (response.data) {
      var data = response.data.data[0]

      data.customer_id_value = {
        label: data.customer_name,
        value: data.customer_id,
      }

      data.branch_id_value = {
        label: data.branch_name,
        value: data.branch_id,
      }

      if (data.sales_quotation_id) {
        data.quotation_id_value = {
          label: "Quotation No. " + data.sales_quotation_id,
          value: data.sales_quotation_id,
        }
      }
      data.is_vat = data.vat_type === "VAT" ? true : false
      data.withholding_percentage = parseInt(data.withholding_percentage)
      data.original_withholding_percentage = parseInt(
        data.withholding_percentage
      )
      var ordered_items = data.sales_order_items.map((item) => {
        var info = item
        info.value = item.item_id
        info.subtotal = item.item_total
        info.item_id_value = { label: item.item_name, value: item.item_id }
        info.priceValue = { label: item.price, value: item.price }
        info.unit_value = item.unit + "|" + item.item_unit_id
        info.is_old_item = true
        return info
      })
      setOrderItems(ordered_items)

      // to fetch items and set the filtered items
      // fetchItemsByBranch(addDetails.branch_id, ordered_items);

      setAddDetails(data)
      setPrevAttachments(data.sales_order_attachments)
    }
  }

  function handlePaymentChange(e) {
    const paymentInfo = { ...addDetails }
    const { name, value } = e.target
    if (name === "service_fee" || name === "delivery_fee") {
      const paymentEdit = { ...addDetails }
      paymentEdit[name] = value
      setAddDetails(paymentEdit)
      setIsChanged(!isChanged)
    }

    if (name === "to_bank_id" || name === "from_bank_id") {
      paymentInfo[name] = value
    } else {
      paymentInfo[name] = value
    }

    setAddDetails(paymentInfo)
  }

  const handleRemove = (selectedFile) => {
    var newlist = fileList.filter((file) => {
      return selectedFile.uid !== file.uid
    })
    setFileList(newlist)
    console.log(fileList)
  }

  const handleBeforeUpload = (file) => {
    const isImage = file.type.startsWith("image/")
    const isPDF = file.type === "application/pdf"
    const isWord =
      file.type === "application/msword" ||
      file.type ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"

    if (!(isImage || isPDF || isWord)) {
      // Show error message or handle invalid file type
      return false // Prevent upload
    }

    if (file.size > 2000000) {
      console.log("if exceed")
      setShowFileExceedModal(true)
      return false // Prevent upload
    }

    // Compressing file
    new Compressor(file, {
      quality: 0.6,
      success: (compressedResult) => {
        setFileList([...fileList, compressedResult])
      },
    })

    return false // Prevent default upload behavior
  }

  function handleRemoveItemAttachment(url) {
    var newList = prevAttachments.filter((data) => {
      return data.file_url !== url
    })
    console.log(newList)
    setPrevAttachments(newList)
    setPreview(false)
  }

  function handleAddNewRow() {
    const newItem = {
      item_id: "",
      name: "",
      qty: "",
      discount: 0,
      unit: "",
      price: "",
      type: "",
      se_id: "0",
    }
    setAdditionalItemList((oldItems) => [...oldItems, newItem])
  }

  function handleDelRow(id) {
    setIsChanged(true)

    const newList = [...additionalItemList]
    newList.splice(id, 1)
    setAdditionalItemList(newList)

    setTimeout(() => setIsChanged(false), 1)
  }

  function handleAddTblChange(e, id) {
    setIsChanged(true)

    const { name, value } = e.target
    var temp = additionalItemList

    if (name === "qty" || name === "price") {
      temp.map((item, index) => {
        if (index === id) {
          item[name] = value
          item.amount = item.qty * item.price
          item.total = item.qty * item.price

          return item
        }
      })
    } else {
      temp.map((item, index) => {
        if (index === id) {
          item[name] = value
          return item
        }
      })
    }
    setAdditionalItemList(temp)
    setTimeout(() => setIsChanged(false), 1)
  }

  async function fetchBranches() {
    setBranches([])
    const response = await getAllBranches()

    if (response.data) {
      let result = response.data.data.map((a) => {
        var info = {}
        info.name = "branch_id"
        info.for = "branch_id"
        info.label = a.name
        info.value = a.id
        info.value_variable = "branch_id_value"
        return info
      })
      setBranches(result)
    }
  }

  async function fetchCustomers(type, customer_id) {
    setCustomers([])
    const response = await getCustomer({})
    if (response.data) {
      var customers = response.data.data.sort((a, b) =>
        a.trade_name > b.trade_name ? 1 : b.trade_name > a.trade_name ? -1 : 0
      )

      var customersData = customers.map((customer) => {
        var info = {
          ...customer,
          id: customer.id,
          name: "customer_id",
          label: customer.trade_name,
          value: customer.id,
          value_variable: "customer_id_value",
          vat_type: customer.vat_type,
          withholding_percentage: customer.withholding_percentage,
        }

        return info
      })
      setCustomers(customersData)
    }
    if (type === "set") {
      //to set customer vat details
      handleSetCustomerVatDetails(customersData, customer_id)
    }
  }

  const handleSearchItem = (newValue) => {
    if (newValue.length > 2) {
      //if length of the input is greater than 3, it will call the search api
      handleFetchItems(newValue, setAllItems)
    }
  }

  // new api for searching items
  async function handleFetchItems(value, setAllItems) {
    setAllItems([])
    const response = await getItemPriceByBranch({
      name: value,
      branch_id: addDetails.branch_id,
    })
    if (response.data) {
      var itemsList = response.data.data.map((data) => {
        var info = data
        info.label = data.item_name
        info.value = data.item_id
        info.name = "item_id"
        info.item_name = data.item_name
        info.item_code = data.item_code
        // item_unit_id= data.item_unit_id
        info.item_id = data.item_id
        info.unit = data.unit
        info.wholesale_price = data.wholesale_price
        info.retail_price = data.retail_price
        info.special_price_1 = data.special_price_1
        info.special_price_2 = data.special_price_2
        info.special_price_3 = data.special_price_3
        info.cost_price = data.cost_price
        info.current_qty = data.current_qty
        info.item_units = data.item_units

        return info
      })
      setAllItems(itemsList)
    } else {
      response.error?.data?.messages.map((data) => {
        return toast.error(data, {
          style: toastStyle(),
        })
      })
    }
  }

  async function fetchItemsByBranch(branch_id, ordered_items, type) {
    setAllItems([])
    setFilteredItems([])
    const response = await getItemPriceByBranch(branch_id)
    if (response.data) {
      var data = response.data.data
        .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
        .map((data) => {
          return {
            label: data.item_name,
            value: data.item_id,
            name: "item_id",
            item_name: data.item_name,
            // item_unit_id: data.item_unit_id,
            item_id: data.item_id,
            unit: data.unit,
            wholesale_price: data.wholesale_price,
            retail_price: data.retail_price,
            special_price_1: data.special_price_1,
            special_price_2: data.special_price_2,
            special_price_3: data.special_price_3,
            cost_price: data.cost_price,
            current_qty: data.current_qty,
            item_units: data.item_units,
          }
        })
      setAllItems(data)
      if (edit || type === "quotation") {
        // const filteredOptions = data?.filter(option => {
        //     return !ordered_items.find(item => item?.item_unit_id === option.item_unit_id);
        // });
        // setFilteredItems(filteredOptions);
        handleSetItemUnitOption(ordered_items, data)
      } else {
        setFilteredItems(data)
      }
    }
  }

  //FOR EDIT to filter item options and set unit dropdown values per item
  function handleSetItemUnitOption(items, item_options) {
    var itemList = items?.map((item) => {
      var info = item
      var units = item_options?.filter((data) => data.value === item.value)
      info.item_units = units[0]?.item_units
      var prices = []
      units[0]?.item_units.map((data) => {
        if (
          data.wholesale_price !== null &&
          data.wholesale_price !== "0.0000"
        ) {
          prices.push({
            name: "price",
            label: data.wholesale_price,
            value: data.wholesale_price,
          })
        }
        if (data.retail_price !== null && data.retail_price !== "0.0000") {
          prices.push({
            name: "price",
            label: data.retail_price,
            value: data.retail_price,
          })
        }
        if (
          data.special_price_1 !== null &&
          data.special_price_1 !== "0.0000"
        ) {
          prices.push({
            name: "price",
            label: data.special_price_1,
            value: data.special_price_1,
          })
        }
        if (
          data.special_price_2 !== null &&
          data.special_price_2 !== "0.0000"
        ) {
          prices.push({
            name: "price",
            label: data.special_price_2,
            value: data.special_price_2,
          })
        }
        if (
          data.special_price_3 !== null &&
          data.special_price_3 !== "0.0000"
        ) {
          prices.push({
            name: "price",
            label: data.special_price_3,
            value: data.special_price_3,
          })
        }
        if (data.cost_price !== null && data.cost_price !== "0.0000") {
          prices.push({
            name: "price",
            label: data.cost_price,
            value: data.cost_price,
          })
        }
        // save the item prices in each item array
        info.item_prices = prices
      })
      return info
    })
    setOrderItems(itemList)

    const filteredOptions = item_options.filter((option) => {
      return !items.find((item) => item.item_id === option.item_id)
    })
    setFilteredItems(filteredOptions)
  }

  //DISABLE SCROLL FUNCTION
  function limitScroll() {
    var numericInputs = document.querySelectorAll(".numeric-input")
    numericInputs.forEach(function (input) {
      input.addEventListener("wheel", function (e) {
        e.preventDefault()
      })
    })
  }
  limitScroll()

  async function fetchSalesQuotation(id, status) {
    const response = await getSalesQuotation({ id: id, status: status })
    if (response.data) {
      var quotations = response.data.data.map((data) => {
        var info = data
        info.name = "quotation_id"
        info.value_variable = "quotation_id_value"
        info.label =
          "Quote No." +
          data.id +
          " " +
          data.customer_name +
          " - " +
          numberFormat(data.grand_total)
        info.value = data.id
        info.sales_quotation_id = data.id
        return info
      })
      setQuotations(quotations)
      // to set order
      if (id !== "") {
        handleSelectChange(quotations[0])
      }
    }
  }

  async function fetchBanks() {
    const response = await getAllBanks()
    if (response.data) {
      if (response.data.status === "success") {
        setBanks(response.data.data)
      }
    }
  }

  // async function fetchEmployees() {
  //     setEmployees([]);
  //     const response = await getAllEmployees();

  //     if (response.data) {
  //     let result = response.data.data.filter((data) => {return data.department === "Office Staff"})
  //     .map((data) => {
  //         return {
  //             label: data.first_name + " " + data.last_name,
  //             value: data.id,
  //             name: "acknowledged_by",
  //             value_variable: "acknowledged_by_value"
  //         };
  //     });
  //     setEmployees(result);
  //     }
  // }

  async function fetchEmployees() {
    setEmployees([])
    const response = await getAllEmployees()

    if (response.data) {
      let result = response.data.data.map((data) => {
        return {
          for: "employee_id",
          label: data.first_name + " " + data.last_name,
          value: data.id,
        }
      })
      setEmployees(result)
    }
  }

  // DATA FETCHING
  useEffect(() => {
    fetchEmployees()
    fetchBranches()
    fetchBanks()

    if (edit) {
      fetchSalesOrder()
      fetchCustomers()
    } else if (add && id) {
      fetchSalesQuotation(id, "")
    } else {
      fetchSalesQuotation("", "pending")
      fetchCustomers()
    }
  }, [])

  function handleSetCustomerVatDetails(customers, customer_id) {
    setIsChanged(true)

    var customer_details = customers.filter((data) => {
      return data.id === customer_id
    })
    setAddDetails((prevAddDetails) => ({
      ...prevAddDetails,
      vat_type: customer_details[0]?.vat_type, // set vat
      withholding_percentage: parseInt(
        customer_details[0]?.withholding_percentage
      ), // set wht
      original_withholding_percentage: parseInt(
        customer_details[0]?.withholding_percentage
      ), // set original wht
      is_vat: customer_details[0]?.vat_type === "VAT" ? true : false, // set vat checker
    }))

    setTimeout(() => setIsChanged(false), 1)
  }

  // useEffect(() => {
  //     if(add) {
  //         fetchItemsByBranch(addDetails.branch_id, []);
  //     }
  // }, [addDetails.branch_id]);

  // FOR DYNAMIC CALCULATION
  useEffect(() => {
    var calcSubtotal = 0
    var calcDiscountSubtotal = 0
    var tempDiscount = addDetails.discount ? parseFloat(addDetails.discount) : 0
    var tempServiceFee = addDetails.service_fee
      ? parseFloat(addDetails.service_fee)
      : 0

    var itemListSubtotal = orderItems
      .map((item) => parseFloat(item.amount))
      .reduce((a, b) => a + b, 0)

    // item subtotal with discount per item
    calcSubtotal = itemListSubtotal
    // item subtotal minus discount
    calcDiscountSubtotal = calcSubtotal - tempDiscount

    var _wht = 0
    var vatable_sales = 0
    var vat = 0

    if (addDetails.vat_type === "VAT") {
      vatable_sales = parseFloat(calcDiscountSubtotal) / 1.12
      vat = parseFloat(calcDiscountSubtotal) - vatable_sales
      var percentage =
        addDetails?.withholding_percentage === 1
          ? 0.01
          : addDetails?.withholding_percentage === 2
          ? 0.02
          : 0

      // witholding tax if vat is checked
      var tempVatSales = vatable_sales ? parseFloat(vatable_sales) : 0
      var tempWHTPercentage = percentage ? parseFloat(percentage) : 0
      _wht = parseFloat(tempVatSales) * tempWHTPercentage
    }
    var _grand_total_without_fee = calcDiscountSubtotal - _wht

    setAddDetails((prev) => {
      return {
        ...prev,
        grand_total: _grand_total_without_fee + tempServiceFee,
        // grand_total: calcSubtotal + tempServiceFee - tempDiscount,
        subtotal: calcSubtotal,
        withholding_tax: _wht,
        discounted_subtotal: calcDiscountSubtotal.toFixed(2),
        grandtotal_without_service_fee: _grand_total_without_fee,
        vat: vat,
        vatable_sales: vatable_sales,
      }
    })
  }, [isChanged])

  // FOR DYNAMIC CALCULATION
  // useEffect(() => {

  //     var tempServiceFee = addDetails.service_fee
  //         ? parseFloat(addDetails.service_fee)
  //         : 0;
  //     var tempDeliveryFee = addDetails.delivery_fee
  //         ? parseFloat(addDetails.delivery_fee)
  //         : 0;

  //     var _subtotal = orderItems
  //         .map((item) => parseFloat(item.subtotal))
  //         .reduce((a, b) => a + b, 0);

  //     var _discount = orderItems
  //         .map((item) => parseFloat(item.discount))
  //         .reduce((a, b) => a + b, 0);

  //     var _grandTotal = _subtotal + tempServiceFee + tempDeliveryFee;
  //     setAddDetails((prev) => {
  //         return {
  //             ...prev,
  //             subtotal: _subtotal.toFixed(2),
  //             discount_total: _discount.toFixed(2),
  //             grand_total: _grandTotal.toFixed(2),
  //         };
  //     });
  // }, [isChanged]);

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"SALES"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-4">
          <Col xs={12} lg={7}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {add ? "ADD SALES ORDER" : "EDIT SALES ORDER"}
            </h1>
          </Col>
        </Row>

        {/* content */}
        <div className="edit-form">
          {/* FRANCHISEE SALES INVOICE DETAILS */}
          <Fragment>
            <Row className="mb-4">
              <Col xs={12} lg={4}>
                <span className="edit-label">
                  Sales Quotation
                  {/* <span className="color-red"> *</span> */}
                </span>
                <Select
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select Quotation..."
                  value={addDetails.quotation_id_value}
                  options={quotations}
                  onChange={(e) => handleSelectChange(e)}
                />
              </Col>
              <Col xs={12} lg={4} className="mt-4 mt-lg-0">
                <span className="edit-label">
                  Customer
                  <span className="color-red"> *</span>
                </span>
                <Select
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select Customer..."
                  value={addDetails.customer_id_value}
                  options={customers}
                  onChange={(e) => handleSelectChange(e, "customer")}
                />
                <InputError
                  isValid={isError.customer_id}
                  message={"Branch is required"}
                />
              </Col>
              <Col xs={12} lg={4} className="mt-4 mt-lg-0">
                <span className="edit-label">
                  Customer PO No.
                  {/* <span className="color-red"> *</span> */}
                </span>
                <Form.Control
                  type="text"
                  name="customer_po_no"
                  value={addDetails.customer_po_no}
                  className="nc-modal-custom-text"
                  onChange={(e) => handleAddChange(e)}
                />
                <InputError
                  isValid={isError.invoice_no}
                  message={"Invoice no is required"}
                />
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={12} lg={3} className="mt-4 mt-lg-0">
                <span className="edit-label">
                  Invoice No.
                  {/* <span className="color-red"> *</span> */}
                </span>
                <Form.Control
                  type="text"
                  name="invoice_no"
                  value={addDetails.invoice_no}
                  className="nc-modal-custom-text"
                  onChange={(e) => handleAddChange(e)}
                />
                <InputError
                  isValid={isError.invoice_no}
                  message={"Invoice no is required"}
                />
              </Col>
              <Col xs={12} lg={4} className="mt-4 mt-lg-0">
                <span className="edit-label">
                  Branch
                  <span className="color-red"> *</span>
                </span>
                <Select
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select Branch..."
                  value={branches.find(
                    (branch) => addDetails.branch_id === branch.value
                  )}
                  options={branches}
                  onChange={(e) => handleSelectChange(e)}
                />
                <InputError
                  isValid={isError.branch_id}
                  message={"Branch is required"}
                />
              </Col>
              <Col xs={12} lg={5}>
                <span className="edit-label">
                  Delivery Address
                  <span className="color-red"> *</span>
                </span>
                <Form.Control
                  type="text"
                  name="address"
                  value={addDetails.address}
                  className="nc-modal-custom-text"
                  onChange={(e) => handleAddChange(e)}
                />
                <InputError
                  isValid={isError.address}
                  message={"Franchisee Branch is required"}
                />
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={12} lg={4} className="mt-4 mt-lg-0">
                <span className="edit-label">Sales Date</span>
                <span className="color-red"> *</span>
                <Form.Control
                  type="date"
                  name="sales_date"
                  className="nc-modal-custom-text"
                  defaultValue={addDetails.sales_date}
                  onChange={(e) => handleAddChange(e)}
                />
              </Col>
              <Col xs={12} lg={4} className="mt-4 mt-lg-0">
                <span className="edit-label">Delivery Date</span>
                <span className="color-red"> *</span>
                <Form.Control
                  type="date"
                  name="delivery_date"
                  className="nc-modal-custom-text"
                  defaultValue={addDetails.delivery_date}
                  onChange={(e) => handleAddChange(e)}
                />
                <InputError
                  isValid={isError.delivery_date}
                  message={"Franchisee Branch is required"}
                />
              </Col>
              <Col xs={12} lg={4}>
                <span className="edit-label">Contact No.</span>
                <Form.Control
                  type="text"
                  name="contact_no"
                  value={addDetails.contact_no}
                  className="nc-modal-custom-text"
                  onChange={(e) => handleAddChange(e)}
                />
                <InputError
                  isValid={isError.contact_no}
                  message={"Franchisee Branch is required"}
                />
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={12} lg={4} className="mt-4 mt-lg-0">
                <span className="edit-label">
                  Ship Via
                  <span className="color-red"> *</span>
                </span>
                <select
                  className="nc-modal-custom-select"
                  name="ship_via"
                  value={addDetails.ship_via}
                  onChange={(e) => handleAddChange(e)}
                >
                  <option value="">Select...</option>
                  <option value="pick_up">Pick Up</option>
                  <option value="delivery">Delivery</option>
                </select>
                <InputError
                  isValid={isError.ship_via}
                  message={"Ship via is required"}
                />
              </Col>
              <Col>
                <span className="edit-label">Acknowledged by</span>
                <Select
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder={
                    addDetails.acknowledged_by_name
                      ? addDetails.acknowledged_by_name
                      : "Select employee..."
                  }
                  value={employees.find(
                    (employee) => addDetails.employee_id === employee.value
                  )}
                  options={employees}
                  onChange={(e) => handleSelectChange(e)}
                />
              </Col>
              <Col>
                <span className="edit-label">Remarks</span>
                <Form.Control
                  type="textarea"
                  name="remarks"
                  className="nc-modal-custom-text"
                  defaultValue={addDetails.remarks}
                  onChange={(e) => handleAddChange(e)}
                />
              </Col>
            </Row>
          </Fragment>

          {/* ORDER ITEMS */}
          <Row className="mt-4 pt-3">
            <Col>
              <span className="edit-label mb-2">
                Choose Items to Order
                <span className="color-red"> *</span>
              </span>
              <div className="edit-purchased-items">
                {orderItems.length !== 0 ? (
                  <Table>
                    <thead>
                      <tr>
                        <th className="color-gray">item</th>
                        <th className="color-gray">quantity</th>
                        <th className="color-gray">unit</th>
                        <th className="color-gray">item code</th>
                        <th className="color-gray">price</th>
                        <th className="color-gray">discount</th>
                        <th className="color-gray">total</th>
                        <th className="color-gray">remarks</th>
                        <th className="color-gray">actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {orderItems.map((item, index) => {
                        return (
                          <tr>
                            <td>
                              <Form.Control
                                type="text"
                                name="description"
                                placeholder={"Description"}
                                className="nc-modal-custom-input mb-1 w-full"
                                value={item.description}
                                onChange={(e) =>
                                  handleOrderItemsChange(e, index)
                                }
                              />
                              <InputError
                                isValid={isError.description}
                                message={"Description is required"}
                              />
                              <SearchBox
                                showSearch
                                value={item.item_id_value}
                                placeholder={"Search Item..."}
                                className="react-select-container w-full"
                                dropdownClassName="z-large antdesign-custom-dropdown"
                                style={antdesignSelectStyle}
                                defaultActiveFirstOption={false}
                                suffixIcon={null}
                                filterOption={false}
                                onSearch={handleSearchItem}
                                onChange={(e) =>
                                  handleOrderItemsChange(e, index, "item_id")
                                }
                                notFoundContent={null}
                                options={(allItems || []).map((d) => ({
                                  value: d.value,
                                  label: d.label,
                                }))}
                              />
                              {/* <Select
                                                                className="react-select-container"
                                                                classNamePrefix="react-select"
                                                                placeholder="Select item..."
                                                                value={
                                                                    item.item_id_value
                                                                }
                                                                options={
                                                                    filteredItems
                                                                }
                                                                onChange={(e) =>
                                                                    handleOrderItemsChange(
                                                                        e,
                                                                        index,
                                                                        "item_id"
                                                                    )
                                                                }
                                                            /> */}
                              {item.exceed ? <p></p> : ""}
                            </td>
                            <td>
                              <Form.Control
                                type="number"
                                name="qty"
                                className="hide-spinner numeric-input"
                                min={1}
                                value={item.qty}
                                onChange={(e) =>
                                  handleOrderItemsChange(e, index)
                                }
                              />
                              {item.exceed ? (
                                <h7 className="red">Quantity exceeds</h7>
                              ) : (
                                ""
                              )}
                              <InputError
                                isValid={isError.qty}
                                message={"Quantity is required"}
                              />
                            </td>
                            <td>
                              {item.item_id === "" ||
                              item.item_id === undefined ||
                              item.is_old_item ? (
                                <Form.Control
                                  type="text"
                                  name="unit"
                                  value={item.unit}
                                  className="numeric-input"
                                  onChange={(e) =>
                                    handleOrderItemsChange(e, index)
                                  }
                                />
                              ) : (
                                <Form.Select
                                  name="unit"
                                  id={item.id}
                                  className="numeric-input"
                                  value={item.unit_value}
                                  onChange={(e) =>
                                    handleOrderItemsChange(e, index)
                                  }
                                >
                                  <option value="">Select</option>
                                  {item.item_units?.map((data) => {
                                    return (
                                      <option
                                        value={data.unit_from + "|" + data.id}
                                      >
                                        {data.unit_from}
                                      </option>
                                    )
                                  })}
                                </Form.Select>
                              )}
                              {item.exceed ? <p></p> : ""}
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                name="item_code"
                                className="numeric-input"
                                value={item.item_code}
                                disabled
                              />
                            </td>
                            <td>
                              {item.has_item_price ? (
                                <>
                                  <SearchBox
                                    showSearch
                                    value={item.priceValue}
                                    placeholder={"Select price..."}
                                    className="react-select-container w-full"
                                    dropdownClassName="z-large antdesign-custom-dropdown"
                                    style={antdesignSelectStyle}
                                    defaultActiveFirstOption={true}
                                    suffixIcon={null}
                                    filterOption={false}
                                    // onSearch={handleSearchItem}
                                    onChange={(e) =>
                                      handleOrderItemsChange(e, index, "prices")
                                    }
                                    options={item.item_prices}
                                    notFoundContent={null}
                                  />
                                  {/* <Select
                                    className="react-select-container numeric-input"
                                    classNamePrefix="react-select"
                                    placeholder="Select price..."
                                    value={item.priceValue}
                                    options={item.item_prices}
                                    onChange={(e) =>
                                      handleOrderItemsChange(e, index, "prices")
                                    }
                                  /> */}
                                  <InputError
                                    isValid={isError.price}
                                    message={"Price is required"}
                                  />
                                  {item.exceed ? <p></p> : ""}
                                </>
                              ) : (
                                <>
                                  {/* <SearchBox
                                    showSearch
                                    value={item.priceValue}
                                    placeholder={"Select price..."}
                                    className="react-select-container w-full"
                                    dropdownClassName="z-large antdesign-custom-dropdown"
                                    style={antdesignSelectStyle}
                                    defaultActiveFirstOption={true}
                                    suffixIcon={null}
                                    filterOption={false}
                                    // onSearch={handleSearchItem}
                                    onChange={(e) =>
                                      handleOrderItemsChange(e, index, "prices")
                                    }
                                    options={item.item_prices}
                                    notFoundContent={null}
                                  /> */}
                                  <Form.Control
                                    type="number"
                                    name="price"
                                    className="hide-spinner numeric-input"
                                    min={1}
                                    value={item.price}
                                    onChange={(e) =>
                                      handleOrderItemsChange(e, index)
                                    }
                                  />
                                  <InputError
                                    isValid={isError.price}
                                    message={"Price is required"}
                                  />
                                </>
                              )}
                            </td>
                            <td>
                              <div className="d-flex">
                                <Form.Control
                                  className="mb-1 numeric-input"
                                  type="number"
                                  name="discount_percentage"
                                  value={formatDecimal(
                                    item.discount_percentage
                                  )}
                                  onChange={(e) =>
                                    handleOrderItemsChange(e, index)
                                  }
                                />
                                <p className="ms-1 fs-6 mt-3">%</p>
                              </div>
                              <div className="d-flex">
                                <Form.Control
                                  type="number"
                                  name="discount_amount"
                                  className="numeric-input"
                                  value={formatDecimal(item.discount_amount)}
                                  onChange={(e) =>
                                    handleOrderItemsChange(e, index)
                                  }
                                  disabled
                                />
                                <p className="ms-1 fs-6 mt-3">₱</p>
                              </div>
                            </td>
                            <td className="color-green numeric-input">
                              {numberFormat(item.amount)}
                              {item.exceed ? <p></p> : ""}
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                name="item_remarks"
                                className="numeric-input"
                                value={item.item_remarks}
                                onChange={(e) =>
                                  handleOrderItemsChange(e, index)
                                }
                              />
                            </td>
                            <td className="text-center">
                              <img
                                alt="delete"
                                src={trash}
                                onClick={() => deleteOrder(index)}
                                className="cursor-pointer"
                              />
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </Table>
                ) : (
                  <div className="entries-not-found">
                    There is no ordered items yet.
                  </div>
                )}
              </div>
              <InputError
                isValid={isError.list}
                message={"Please add an item or additional item"}
              />
            </Col>
          </Row>

          {/* ADD ITEM BUTTON */}
          <Row className="pt-3 PO-add-item">
            <Col xs={6} lg={3}>
              <Button
                type="button"
                className="add-btn"
                disabled={!addDetails.branch_id}
                onClick={() => addNewOrder()}
              >
                Add Item
              </Button>
            </Col>
          </Row>
          {edit && (
            <>
              <div className="mt-4 noPrint mx-3">
                <Row className="review-data mb-2">FILE ATTACHMENTS</Row>
                <Row className="">
                  {prevAttachments &&
                    prevAttachments.map((attachment) => (
                      <Col
                        xs={1}
                        onClick={() => {
                          setPreviewFile(attachment.file_url)
                          setPreview(true)
                        }}
                        className="cursor-pointer preview-container"
                      >
                        <img
                          src={attachment.file_url}
                          className="img-preview"
                          alt=""
                        />
                      </Col>
                    ))}
                  {!prevAttachments ||
                    (prevAttachments.length === 0 && (
                      <Col xs={1}>
                        <div className="no-data-cont d-flex justify-content-left preview-container">
                          <img
                            src={noDataImg}
                            alt="no data found"
                            className="img-preview"
                          />
                        </div>
                      </Col>
                    ))}
                </Row>
              </div>
            </>
          )}
          <Row className="mt-4 mb-2">
            <Col>
              <Dragger
                fileList={fileList}
                onRemove={handleRemove}
                beforeUpload={handleBeforeUpload}
                multiple={false}
                listType="picture"
                progress={{ showInfo: true }}
              >
                <img src={upload} className="cursor-pointer" alt="" />
                <p className="ant-upload-text">
                  Click or drag file to this area to upload
                </p>
              </Dragger>
            </Col>
          </Row>

          {/* <Row className="mt-4 pt-3">
                        <span className="edit-label mb-2">
                            Additional Order Items
                        </span>
                        <div className="edit-purchased-items">
                            {additionalItemList.length !== 0 ? (
                                <Table>
                                    <thead>
                                        <tr>
                                            <th className="color-gray">item</th>
                                            <th className="color-gray">
                                                quantity
                                            </th>
                                            <th className="color-gray">unit</th>
                                            <th className="color-gray">
                                                unit price
                                            </th>
                                            <th className="color-gray">
                                                amount
                                            </th>
                                            <th className="color-gray">
                                                actions
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {additionalItemList.map(
                                            (item, index) => {
                                                return (
                                                    <tr>
                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                name="name"
                                                                value={
                                                                    item.name
                                                                }
                                                                onChange={(e) =>
                                                                    handleAddTblChange(
                                                                        e,
                                                                        index
                                                                    )
                                                                }
                                                            />
                                                            <InputError
                                                                isValid={isError.item_name}
                                                                message={"Item is required"}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="number"
                                                                name="qty"
                                                                className="hide-spinner numeric-input"
                                                                min={1}
                                                                value={
                                                                    item.qty
                                                                }
                                                                onChange={(e) =>
                                                                    handleAddTblChange(
                                                                        e,
                                                                        index
                                                                    )
                                                                }
                                                            />
                                                            <InputError
                                                                isValid={isError.qty2}
                                                                message={"Quantity is required"}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                name="unit"
                                                                value={
                                                                    item.unit
                                                                }
                                                                onChange={(e) =>
                                                                    handleAddTblChange(
                                                                        e,
                                                                        index
                                                                    )
                                                                }
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="number"
                                                                name="price"
                                                                className="hide-spinner numeric-input"
                                                                value={
                                                                    item.price
                                                                }
                                                                onChange={(e) =>
                                                                    handleAddTblChange(
                                                                        e,
                                                                        index
                                                                    )
                                                                }
                                                            />
                                                        </td>
                                                        <td className="color-green">
                                                            {item.qty &&
                                                            item.price
                                                                ? numberFormat(
                                                                      item.price *
                                                                          item.qty
                                                                  )
                                                                : "0.00"}
                                                        </td>
                                                        <td className="text-center">
                                                            <img
                                                                alt="delete"
                                                                src={trash}
                                                                onClick={() =>
                                                                    handleDelRow(
                                                                        index
                                                                    )
                                                                }
                                                                className="cursor-pointer"
                                                            />
                                                        </td>
                                                    </tr>
                                                );
                                            }
                                        )}
                                    </tbody>
                                </Table>
                            ) : (
                                <div className="entries-not-found">
                                    There is no additional purchased items
                                    recorded yet.
                                </div>
                            )}
                        </div>
                    </Row> 
                    <Row className="pt-3 PO-add-item">
                        <Button type="button" onClick={() => handleAddNewRow()}>
                            Add Item
                        </Button>
                    </Row> */}

          <Fragment>
            {/* SUBTOTAL, FREIGHT COST, DISCOUNT, & GRAND TOTAL */}
            <Row className="align-right pt-3">
              <Col xs={8} className="text-end">
                <span className="edit-label color-gray">Subtotal</span>
              </Col>
              <Col xs={1} className="text-end">
                <span className="edit-label align-middle">PHP</span>
              </Col>
              <Col xs={3} className="text-end">
                <span className="edit-label align-middle">
                  {numberFormat(addDetails.subtotal)}
                </span>
              </Col>
            </Row>
            <Row className="align-right pt-3">
              <Col xs={8} className="text-end">
                <span className="edit-label color-gray">Discount</span>
              </Col>
              <Col xs={1} className="text-end">
                <span className="edit-label align-middle">PHP</span>
              </Col>
              <Col xs={3}>
                <Form.Control
                  type="number"
                  name="discount"
                  value={addDetails.discount}
                  className="align-middle nc-modal-custom-text hide-spinner numeric-input"
                  onChange={(e) => handleAddChange(e)}
                />
              </Col>
            </Row>
            <Row className="align-right pt-3">
              <Col xs={8} className="text-end">
                <span className="edit-label color-gray">
                  Discounted Subtotal
                </span>
              </Col>
              <Col xs={1} className="text-end">
                <span className="edit-label align-middle">PHP</span>
              </Col>
              <Col xs={3} className="text-end">
                <span className="edit-label align-middle">
                  {numberFormat(addDetails.discounted_subtotal)}
                </span>
              </Col>
            </Row>
            <Row className="align-right pt-3">
              <Col xs={5} lg={6}></Col>
              <Col xs={3} lg={1} className="text-end print-table-footer-label">
                <Form.Group className="" controlId="formBasicCheckbox">
                  <Form.Check
                    type="checkbox"
                    label="VAT"
                    name="is_vat"
                    className="pt-2"
                    checked={addDetails.vat_type === "VAT"}
                    onChange={(e) => handleAddChange(e)}
                    // disabled
                  />
                </Form.Group>
              </Col>
              <Col xs={1} className="text-end">
                <span className="edit-label align-middle">PHP</span>
              </Col>
              <Col xs={3} className="text-end print-table-footer-data ps-4">
                {addDetails.vat ? numberFormat(addDetails.vat) : "0.00"}
              </Col>
            </Row>
            {addDetails.vat_type === "VAT" && (
              <>
                <Row className="align-right pt-3">
                  <Col xs={8} className="text-end print-table-footer-label">
                    Vatable Sales
                  </Col>
                  <Col xs={1} className="text-end">
                    <span className="edit-label align-middle">PHP</span>
                  </Col>
                  <Col xs={3} className="text-end print-table-footer-data ps-4">
                    {addDetails.vatable_sales
                      ? numberFormat(addDetails.vatable_sales)
                      : "0.00"}
                  </Col>
                </Row>
                <Row className="align-right pt-3">
                  <Col
                    xs={2}
                    lg={3}
                    className="text-end pt-2 print-table-footer-label"
                  >
                    WHT
                  </Col>
                  <Col
                    xs={3}
                    lg={1}
                    className="text-end print-table-footer-label"
                  >
                    <Form.Group className="" controlId="formBasicCheckbox">
                      <Form.Check
                        type="radio"
                        label="1%"
                        name="withholding_percentage"
                        value="1"
                        className="pt-2"
                        style={{ marginLeft: "2rem" }}
                        checked={addDetails.withholding_percentage === 1}
                        onChange={(e) => handleAddChange(e)}
                        // disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col
                    xs={3}
                    xl={1}
                    className="text-end print-table-footer-label"
                  >
                    <Form.Group className="" controlId="formBasicCheckbox">
                      <Form.Check
                        type="radio"
                        label="2%"
                        name="withholding_percentage"
                        value="2"
                        className="pt-2"
                        style={{ marginLeft: "2rem" }}
                        checked={addDetails.withholding_percentage === 2}
                        onChange={(e) => handleAddChange(e)}
                        // disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={1} className="text-end">
                    <span className="edit-label align-middle">PHP</span>
                  </Col>
                  <Col xs={3} className="text-end print-table-footer-data ps-4">
                    {addDetails.withholding_tax
                      ? numberFormat(addDetails.withholding_tax)
                      : "0.00"}
                  </Col>
                </Row>
              </>
            )}
            <Row className="align-right pt-3">
              <Col xs={8} className="text-end">
                <span className="edit-label color-gray">Grand Total</span>
              </Col>
              <Col xs={1} className="text-end">
                <span className="edit-label align-middle">PHP</span>
              </Col>
              <Col xs={3} className="text-end">
                <span className="edit-label align-middle">
                  {addDetails.grandtotal_without_service_fee
                    ? numberFormat(addDetails.grandtotal_without_service_fee)
                    : "0.00"}
                </span>
              </Col>
            </Row>
            <Row className="align-right pt-3">
              <Col xs={8} className="text-end">
                <span className="edit-label color-gray">Service Fee</span>
              </Col>
              <Col xs={1} className="text-end">
                <span className="edit-label align-middle">PHP</span>
              </Col>
              <Col xs={3}>
                <Form.Control
                  type="number"
                  name="service_fee"
                  value={addDetails.service_fee}
                  className="align-middle nc-modal-custom-text hide-spinner numeric-input"
                  onChange={(e) => {
                    handleAddChange(e)
                  }}
                />
              </Col>
            </Row>
            <Row className="align-right pt-3">
              <Col xs={8} className="text-end">
                <span className="edit-label color-gray">Total Amount Due</span>
              </Col>
              <Col xs={1} className="text-end">
                <span className="edit-label align-middle">PHP</span>
              </Col>
              <Col xs={3} className="text-end">
                <span className="edit-label align-middle">
                  {addDetails.grand_total
                    ? numberFormat(addDetails.grand_total)
                    : "0.00"}
                </span>
              </Col>
            </Row>
            {/* COMMENTED KAY WALA DAW PAYMENT ANG SALES ORDER (2/16/2024) */}
            {/* {(addDetails.payment_status !== "closed_bill" ) && (
                            <>
                                <Row className="align-right pt-3">
                                    <Col xs={2} className="text-end">
                                        <span className="edit-label color-gray">
                                            Payment Type
                                        </span>
                                    </Col>
                                    <Col xs={1} className="text-end"></Col>
                                    <Col xs={3}>
                                        <Form.Check
                                            inline
                                            label="Cash"
                                            name="payment_type"
                                            value="cash"
                                            type="radio"
                                            defaultChecked={
                                                addDetails.payment_type ===
                                                "cash"
                                            }
                                            onClick={(e) => {
                                                handlePaymentChange(e);
                                            }}
                                        />
                                        <Form.Check
                                            inline
                                            label="Check"
                                            name="payment_type"
                                            type="radio"
                                            value="check"
                                            defaultChecked={
                                                addDetails.payment_type ===
                                                "check"
                                            }
                                            onClick={(e) => {
                                                handlePaymentChange(e);
                                            }}
                                        />
                                        <Form.Check
                                            inline
                                            label="Bank"
                                            name="payment_type"
                                            value="bank"
                                            defaultChecked={
                                                addDetails.payment_type ===
                                                "bank"
                                            }
                                            type="radio"
                                            onClick={(e) => {
                                                handlePaymentChange(e);
                                            }}
                                        />
                                    </Col>
                                </Row>
                                <Row className="align-right pt-3">
                                    <Col xs={3} className="text-end"></Col>
                                    <Col xs={3}>
                                        <Form.Check
                                            inline
                                            label="Others"
                                            name="payment_type"
                                            type="radio"
                                            value="others"
                                            defaultChecked={
                                                addDetails.payment_type ===
                                                "others"
                                            }
                                            onClick={(e) => {
                                                handlePaymentChange(e);
                                            }}
                                        />
                                    </Col>
                                </Row>
                                <Row className="align-right pt-3">
                                    <Col xs={2} className="text-end">
                                        <span className="edit-label color-gray">
                                            Paid Amount
                                            <span className="color-red">
                                                {" "}
                                                *
                                            </span>
                                        </span>
                                    </Col>
                                    <Col xs={1} className="text-end">
                                        <span className="edit-label align-middle">
                                            PHP
                                        </span>
                                    </Col>
                                    <Col xs={3}>
                                        <Form.Control
                                            type="number"
                                            name="paid_amount"
                                            defaultValue={
                                                addDetails.paid_amount
                                            }
                                            className="align-middle nc-modal-custom-text hide-spinner numeric-input"
                                            onChange={(e) =>
                                                handlePaymentChange(e)
                                            }
                                        />
                                    </Col>
                                </Row>
                            </>
                        )} */}
          </Fragment>

          {/* COMMENTED KAY WALA DAW PAYMENT ANG SALES ORDER (2/16/2024) */}
          {/* {(addDetails.payment_status !== "closed_bill" ) && (
                        <>
                            {(addDetails.payment_type ===
                                "cash" && addDetails.paid_amount > 0) && (
                                <>
                                    <div className="mt-5"></div>
                                    <hr />
                                    <div className="payment-header-wrapper mb-5">
                                        <h5 className="payment-header">
                                            Payment Details
                                        </h5>
                                    </div>
                                    <Row className="mt-4 mb-2">
                                        <Col>
                                            <span className="edit-label">
                                                Payment Date
                                                <span className="color-red">
                                                    {" "}
                                                    *
                                                </span>
                                            </span>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Control
                                                type="date"
                                                name="payment_date"
                                                className="nc-modal-custom-text"
                                                defaultValue={
                                                    addDetails.payment_date
                                                }
                                                onChange={(e) =>
                                                    handlePaymentChange(e)
                                                }
                                            />
                                            <InputError
                                                isValid={isError.payment_date}
                                                message={
                                                    "Payment date is required"
                                                }
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-4 mb-2">
                                        <Col>
                                            <span className="edit-label">
                                                Invoice Number
                                                <label className="badge-required">{` *`}</label>
                                            </span>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Control
                                                type="text"
                                                name="invoice_no"
                                                className="nc-modal-custom-text"
                                                value={
                                                    addDetails.invoice_no
                                                }
                                                onChange={(e) =>
                                                    handlePaymentChange(e)
                                                }
                                            />
                                            <InputError
                                                isValid={isError.invoice_no}
                                                message={
                                                    "Invoice Number is required"
                                                }
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-4 mb-2">
                                        <Col>
                                            <span className="edit-label">
                                                Deposit Date
                                                <span className="color-red"> *</span>
                                            </span>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Control
                                                type="date"
                                                name="deposit_date"
                                                className="nc-modal-custom-text"
                                                defaultValue={
                                                    addDetails.deposit_date
                                                }
                                                onChange={(e) => handlePaymentChange(e)}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-4 mb-2">
                                        <Col>
                                            <span className="edit-label">
                                                Deposited To
                                                <span className="color-red">
                                                    {" "}
                                                    *
                                                </span>
                                            </span>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Select
                                                type="text"
                                                name="to_bank_id"
                                                className="nc-modal-custom-text"
                                                value={
                                                    addDetails.to_bank_id
                                                }
                                                onChange={(e) =>
                                                    handlePaymentChange(e)
                                                }
                                            >
                                                <option value="">
                                                    Select a bank...
                                                </option>
                                                {banks.map((data) => {
                                                    return (
                                                        <option value={data.id}>
                                                            {data.name}
                                                        </option>
                                                    );
                                                })}
                                            </Form.Select>
                                            <InputError
                                                isValid={isError.to_bank_id}
                                                message={
                                                    "Bank is required"
                                                }
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-4 mb-2">
                                        <Col>
                                            <span className="edit-label">
                                                Payee
                                            </span>
                                            <Form.Control
                                                type="text"
                                                name="payee"
                                                className="nc-modal-custom-text"
                                                value={addDetails.payee}
                                                onChange={(e) => handlePaymentChange(e)}
                                            />
                                        </Col>
                                        <Col>
                                            <span className="edit-label">
                                                Particulars
                                            </span>
                                            <Form.Control
                                                type="text"
                                                name="particulars"
                                                className="nc-modal-custom-text"
                                                value={addDetails.particulars}
                                                onChange={(e) => handlePaymentChange(e)}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-4 mb-2">
                                        <Col>
                                            <span className="edit-label">
                                                Term (days)
                                                <span className="edit-optional px-2">
                                                    (Optional)
                                                </span>
                                            </span>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Control
                                                type="text"
                                                name="term_day"
                                                className="nc-modal-custom-text"
                                                defaultValue={
                                                    addDetails.term_day
                                                }
                                                onChange={(e) =>
                                                    handlePaymentChange(e)
                                                }
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-4 mb-2">
                                        <Col>
                                            <span className="edit-label">
                                                Remarks
                                                <span className="edit-optional px-2">
                                                    (Optional)
                                                </span>
                                            </span>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Control
                                                as="textarea"
                                                name="payment_remarks"
                                                defaultValue={
                                                    addDetails.payment_remarks
                                                }
                                                className="nc-modal-custom-text"
                                                onChange={(e) =>
                                                    handlePaymentChange(e)
                                                }
                                            />
                                        </Col>
                                    </Row>
                                </>
                            )}

                            {addDetails.payment_type ===
                                "check" && (
                                <>
                                    <div className="mt-5"></div>
                                    <hr />
                                    <div className="payment-header-wrapper mb-5">
                                        <h5 className="payment-header">
                                            Payment Details
                                        </h5>
                                    </div>
                                    <Row className="mt-4 mb-2">
                                        <Col>
                                            <span className="edit-label">
                                                Payment Date
                                                <span className="color-red">
                                                    {" "}
                                                    *
                                                </span>
                                            </span>
                                        </Col>
                                        <Col>
                                            <span className="edit-label">
                                                Invoice Number
                                                <span className="color-red">
                                                    {" "}
                                                    *
                                                </span>
                                            </span>
                                        </Col>
                                        <Col>
                                            <span className="edit-label">
                                                Check Date
                                                <span className="color-red">
                                                    {" "}
                                                    *
                                                </span>
                                            </span>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Control
                                                type="date"
                                                name="payment_date"
                                                className="nc-modal-custom-text"
                                                defaultValue={
                                                    addDetails.payment_date
                                                }
                                                onChange={(e) =>
                                                    handlePaymentChange(e)
                                                }
                                            />
                                        </Col>
                                        <Col>
                                            <Form.Control
                                                type="text"
                                                name="invoice_no"
                                                className="nc-modal-custom-text"
                                                value={
                                                    addDetails.invoice_no
                                                }
                                                onChange={(e) =>
                                                    handlePaymentChange(e)
                                                }
                                            />
                                            <InputError
                                                isValid={isError.invoice_no}
                                                message={
                                                    "Invoice Number is required"
                                                }
                                            />
                                        </Col>
                                        <Col>
                                            <Form.Control
                                                type="date"
                                                name="cheque_date"
                                                className="nc-modal-custom-text"
                                                defaultValue={
                                                    addDetails.cheque_date
                                                }
                                                onChange={(e) =>
                                                    handlePaymentChange(e)
                                                }
                                            />
                                            <InputError
                                                isValid={isError.cheque_date}
                                                message={
                                                    "Check date is required"
                                                }
                                            />
                                        </Col>
                                    </Row>

                                    <Row className="mt-4 mb-2">
                                        <Col>
                                            <span className="edit-label">
                                                Bank Name
                                                <span className="color-red">
                                                    {" "}
                                                    *
                                                </span>
                                            </span>
                                        </Col>
                                        <Col>
                                            <span className="edit-label">
                                                Check Number
                                                <span className="color-red">
                                                    {" "}
                                                    *
                                                </span>
                                            </span>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Control
                                                type="text"
                                                name="bank_name"
                                                className="nc-modal-custom-text"
                                                value={
                                                    addDetails.bank_name
                                                }
                                                onChange={(e) =>
                                                    handlePaymentChange(e)
                                                }
                                            />
                                            <InputError
                                                isValid={isError.bank_name}
                                                message={"Bank is required"}
                                            />
                                        </Col>
                                        <Col>
                                            <Form.Control
                                                type="text"
                                                name="cheque_number"
                                                className="nc-modal-custom-text"
                                                defaultValue={
                                                    addDetails.cheque_number
                                                }
                                                onChange={(e) =>
                                                    handlePaymentChange(e)
                                                }
                                            />
                                            <InputError
                                                isValid={isError.cheque_number}
                                                message={
                                                    "Check number is required"
                                                }
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-4 mb-2">
                                        <Col>
                                            <span className="edit-label">
                                                Deposit Date
                                                <span className="color-red"> *</span>
                                            </span>
                                        </Col>
                                        <Col>
                                            <span className="edit-label">
                                                Deposited To
                                                <span className="color-red">
                                                    {" "}
                                                    *
                                                </span>
                                            </span>
                                        </Col>
                                    </Row>
                                    
                                    <Row className="mt-4 mb-2">
                                        <Col>
                                            <Form.Control
                                                type="date"
                                                name="deposit_date"
                                                className="nc-modal-custom-text"
                                                defaultValue={
                                                    addDetails.deposit_date
                                                }
                                                onChange={(e) => handlePaymentChange(e)}
                                            />
                                        </Col>
                                        <Col>
                                            <Form.Select
                                                type="text"
                                                name="to_bank_id"
                                                className="nc-modal-custom-text"
                                                value={
                                                    addDetails.to_bank_id
                                                }
                                                onChange={(e) =>
                                                    handlePaymentChange(e)
                                                }
                                            >
                                                <option value="">
                                                    Select a bank...
                                                </option>
                                                {banks.map((data) => {
                                                    return (
                                                        <option value={data.id}>
                                                            {data.name}
                                                        </option>
                                                    );
                                                })}
                                            </Form.Select>
                                            <InputError
                                                isValid={isError.to_bank_id}
                                                message={
                                                    "Bank is required"
                                                }
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-4 mb-2">
                                        <Col>
                                            <span className="edit-label">
                                                Payee
                                            </span>
                                            <Form.Control
                                                type="text"
                                                name="payee"
                                                className="nc-modal-custom-text"
                                                value={addDetails.payee}
                                                onChange={(e) => handlePaymentChange(e)}
                                            />
                                        </Col>
                                        <Col>
                                            <span className="edit-label">
                                                Particulars
                                            </span>
                                            <Form.Control
                                                type="text"
                                                name="particulars"
                                                className="nc-modal-custom-text"
                                                value={addDetails.particulars}
                                                onChange={(e) => handlePaymentChange(e)}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-4 mb-2">
                                        <Col>
                                            <span className="edit-label">
                                                Term (days)
                                                <span className="edit-optional px-2">
                                                    (Optional)
                                                </span>
                                            </span>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Control
                                                type="text"
                                                name="term_day"
                                                className="nc-modal-custom-text"
                                                defaultValue={
                                                    addDetails.term_day
                                                }
                                                onChange={(e) =>
                                                    handlePaymentChange(e)
                                                }
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-4 mb-2">
                                        <Col>
                                            <span className="edit-label">
                                                Remarks
                                                <span className="edit-optional px-2">
                                                    (Optional)
                                                </span>
                                            </span>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Control
                                                as="textarea"
                                                name="payment_remarks"
                                                defaultValue={
                                                    addDetails.payment_remarks
                                                }
                                                className="nc-modal-custom-text"
                                                onChange={(e) =>
                                                    handlePaymentChange(e)
                                                }
                                            />
                                        </Col>
                                    </Row>
                                </>
                            )}

                            {(addDetails.payment_type === "online" || addDetails.payment_type === "package_inclusion" || addDetails.payment_type === "others") && (
                                <>
                                    <div className="mt-5"></div>
                                    <hr />
                                    <div className="payment-header-wrapper mb-5">
                                        <h5 className="payment-header">
                                            Payment Details
                                        </h5>
                                    </div>
                                    <Row className="mt-4 mb-2">
                                        <Col>
                                            <span className="edit-label">
                                                Payment Date
                                                <span className="color-red">
                                                    {" "}
                                                    *
                                                </span>
                                            </span>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Control
                                                type="date"
                                                name="payment_date"
                                                className="nc-modal-custom-text"
                                                defaultValue={
                                                    addDetails.payment_date
                                                }
                                                onChange={(e) =>
                                                    handlePaymentChange(e)
                                                }
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-4 mb-2">
                                        <Col>
                                            <span className="edit-label">
                                                Invoice Number
                                                <label className="badge-required">{` *`}</label>
                                            </span>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Control
                                                type="text"
                                                name="invoice_no"
                                                className="nc-modal-custom-text"
                                                value={
                                                    addDetails.invoice_no
                                                }
                                                onChange={(e) =>
                                                    handlePaymentChange(e)
                                                }
                                            />
                                            <InputError
                                                isValid={isError.invoice_no}
                                                message={
                                                    "Invoice Number is required"
                                                }
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-4 mb-2">
                                        <Col>
                                            <span className="edit-label">
                                                Reference Number
                                                <label className="badge-required">{` *`}</label>
                                            </span>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Control
                                                type="text"
                                                name="reference_number"
                                                className="nc-modal-custom-text"
                                                value={
                                                    addDetails.reference_number
                                                }
                                                onChange={(e) =>
                                                    handlePaymentChange(e)
                                                }
                                            />
                                            <InputError
                                                isValid={
                                                    isError.reference_number
                                                }
                                                message={
                                                    "Reference number is required"
                                                }
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-4 mb-2">
                                        <Col>
                                            <span className="edit-label">
                                                Payment Description
                                            </span>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Control
                                                type="text"
                                                name="payment_description"
                                                className="nc-modal-custom-text"
                                                defaultValue={
                                                    addDetails.payment_description
                                                }
                                                onChange={(e) =>
                                                    handlePaymentChange(e)
                                                }
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-4 mb-2">
                                        <Col>
                                            <span className="edit-label">
                                                Deposited Date
                                                <span className="color-red">
                                                    {" "}
                                                    *
                                                </span>
                                            </span>
                                        </Col>
                                        <Col>
                                            <span className="edit-label">
                                                Deposited To
                                                <span className="color-red">
                                                    {" "}
                                                    *
                                                </span>
                                            </span>
                                        </Col>
                                        <Col>
                                            <span className="edit-label">
                                                Term (days)
                                                <span className="edit-optional px-2">
                                                    (Optional)
                                                </span>
                                            </span>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Control
                                                type="date"
                                                name="deposit_date"
                                                className="nc-modal-custom-text"
                                                defaultValue={
                                                    addDetails.deposit_date
                                                }
                                                onChange={(e) => handlePaymentChange(e)}
                                            />
                                        </Col>
                                        <Col>
                                            <Form.Select
                                                type="text"
                                                name="to_bank_id"
                                                className="nc-modal-custom-text"
                                                value={
                                                    addDetails.to_bank_id
                                                }
                                                onChange={(e) =>
                                                    handlePaymentChange(e)
                                                }
                                            >
                                                <option value="">
                                                    Select a bank...
                                                </option>
                                                {banks.map((data) => {
                                                    return (
                                                        <option value={data.id}>
                                                            {data.name}
                                                        </option>
                                                    );
                                                })}
                                            </Form.Select>
                                            <InputError
                                                isValid={isError.to_bank_id}
                                                message={
                                                    "Deposited to is required"
                                                }
                                            />
                                        </Col>
                                        <Col>
                                            <Form.Control
                                                type="text"
                                                name="term_day"
                                                className="nc-modal-custom-text"
                                                defaultValue={
                                                    addDetails.term_day
                                                }
                                                onChange={(e) =>
                                                    handlePaymentChange(e)
                                                }
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-4 mb-2">
                                        <Col>
                                            <span className="edit-label">
                                                Payee
                                            </span>
                                            <Form.Control
                                                type="text"
                                                name="payee"
                                                className="nc-modal-custom-text"
                                                value={addDetails.payee}
                                                onChange={(e) => handlePaymentChange(e)}
                                            />
                                        </Col>
                                        <Col>
                                            <span className="edit-label">
                                                Particulars
                                            </span>
                                            <Form.Control
                                                type="text"
                                                name="particulars"
                                                className="nc-modal-custom-text"
                                                value={addDetails.particulars}
                                                onChange={(e) => handlePaymentChange(e)}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-4 mb-2">
                                        <Col>
                                            <span className="edit-label">
                                                Remarks
                                                <span className="edit-optional px-2">
                                                    (Optional)
                                                </span>
                                            </span>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Control
                                                as="textarea"
                                                name="payment_remarks"
                                                defaultValue={
                                                    addDetails.payment_remarks
                                                }
                                                className="nc-modal-custom-text"
                                                onChange={(e) =>
                                                    handlePaymentChange(e)
                                                }
                                            />
                                        </Col>
                                    </Row>
                                </>
                            )}
                            {(addDetails.payment_type === "bank") && (
                                <>
                                    <div className="mt-5"></div>
                                    <hr />
                                    <div className="payment-header-wrapper mb-5">
                                        <h5 className="payment-header">
                                            Payment Details
                                        </h5>
                                    </div>
                                    <Row className="mt-4 mb-2">
                                        <Col>
                                            <span className="edit-label">
                                                Payment Date
                                                <span className="color-red">
                                                    {" "}
                                                    *
                                                </span>
                                            </span>
                                        </Col>
                                        <Col>
                                            <span className="edit-label">
                                                Invoice Number
                                                <label className="badge-required">{` *`}</label>
                                            </span>
                                        </Col>
                                        <Col>
                                            <span className="edit-label">
                                                Reference Number
                                                <label className="badge-required">{` *`}</label>
                                            </span>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Control
                                                type="date"
                                                name="payment_date"
                                                className="nc-modal-custom-text"
                                                defaultValue={
                                                    addDetails.payment_date
                                                }
                                                onChange={(e) =>
                                                    handlePaymentChange(e)
                                                }
                                            />
                                        </Col>
                                        <Col>
                                            <Form.Control
                                                type="text"
                                                name="invoice_no"
                                                className="nc-modal-custom-text"
                                                value={
                                                    addDetails.invoice_no
                                                }
                                                onChange={(e) =>
                                                    handlePaymentChange(e)
                                                }
                                            />
                                            <InputError
                                                isValid={isError.invoice_no}
                                                message={
                                                    "Invoice Number is required"
                                                }
                                            />
                                        </Col>
                                        <Col>
                                            <Form.Control
                                                type="text"
                                                name="reference_number"
                                                className="nc-modal-custom-text"
                                                value={
                                                    addDetails.reference_number
                                                }
                                                onChange={(e) =>
                                                    handlePaymentChange(e)
                                                }
                                            />
                                            <InputError
                                                isValid={
                                                    isError.reference_number
                                                }
                                                message={
                                                    "Reference number is required"
                                                }
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-4 mb-2">
                                        <Col>
                                            <span className="edit-label"> Deposited From </span>
                                            <Form.Select
                                                type="text"
                                                name="from_bank_id"
                                                className="nc-modal-custom-text"
                                                value={addDetails.from_bank_id}
                                                onChange={(e) => handlePaymentChange(e)}
                                            >
                                                <option value="">
                                                    Select a bank...
                                                </option>
                                                {banks.map((data) => {
                                                    return (
                                                        <option value={data.id}>
                                                            {data.name}
                                                        </option>
                                                    );
                                                })}
                                            </Form.Select>
                                        </Col>
                                        <Col>
                                            <span className="edit-label"> From Account No </span>
                                            <Form.Control
                                                type="text"
                                                name="from_account_no"
                                                className="nc-modal-custom-text"
                                                value={addDetails.from_account_no}
                                                onChange={(e) =>handlePaymentChange(e)}
                                            />
                                            <InputError
                                                isValid={isError.from_account_no}
                                                message={"Account number is required"}
                                            />
                                        </Col>
                                        <Col>
                                            <span className="edit-label"> From Account Name </span>
                                            <Form.Control
                                                type="text"
                                                name="from_account_name"
                                                className="nc-modal-custom-text"
                                                value={addDetails.from_account_name}
                                                onChange={(e) =>handlePaymentChange(e)}
                                            />
                                            <InputError
                                                isValid={isError.from_account_name}
                                                message={"Account name is required"}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-4 mb-2">
                                        <Col>
                                            <span className="edit-label"> Deposited to </span>
                                            <Form.Select
                                                type="text"
                                                name="to_bank_id"
                                                className="nc-modal-custom-text"
                                                value={addDetails.to_bank_id}
                                                onChange={(e) => handlePaymentChange(e)}
                                            >
                                                <option value="">
                                                    Select a bank...
                                                </option>
                                                {banks.map((data) => {
                                                    return (
                                                        <option value={data.id}>
                                                            {data.name}
                                                        </option>
                                                    );
                                                })}
                                            </Form.Select>
                                        </Col>
                                        <Col>
                                            <span className="edit-label"> to Account No </span>
                                            <Form.Control
                                                type="text"
                                                name="to_account_no"
                                                className="nc-modal-custom-text"
                                                value={addDetails.to_account_no}
                                                onChange={(e) =>handlePaymentChange(e)}
                                            />
                                            <InputError
                                                isValid={isError.to_account_no}
                                                message={"Account number is required"}
                                            />
                                        </Col>
                                        <Col>
                                            <span className="edit-label"> to Account Name </span>
                                            <Form.Control
                                                type="text"
                                                name="to_account_name"
                                                className="nc-modal-custom-text"
                                                value={addDetails.to_account_name}
                                                onChange={(e) =>handlePaymentChange(e)}
                                            />
                                            <InputError
                                                isValid={isError.to_account_name}
                                                message={"Account name is required"}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-4 mb-2">
                                        <Col>
                                            <span className="edit-label">
                                                Payment Description
                                            </span>
                                            <Form.Control
                                                type="text"
                                                name="payment_description"
                                                className="nc-modal-custom-text"
                                                defaultValue={
                                                    addDetails.payment_description
                                                }
                                                onChange={(e) =>
                                                    handlePaymentChange(e)
                                                }
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-4 mb-2">
                                        <Col>
                                            <span className="edit-label">
                                                Deposited Date
                                                <span className="color-red">
                                                    {" "}
                                                    *
                                                </span>
                                            </span>
                                        </Col>
                                        <Col>
                                            <span className="edit-label">
                                                Term (days)
                                                <span className="edit-optional px-2">
                                                    (Optional)
                                                </span>
                                            </span>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Control
                                                type="date"
                                                name="deposit_date"
                                                className="nc-modal-custom-text"
                                                defaultValue={
                                                    addDetails.deposit_date
                                                }
                                                onChange={(e) => handlePaymentChange(e)}
                                            />
                                        </Col>
                                        <Col>
                                            <Form.Control
                                                type="text"
                                                name="term_day"
                                                className="nc-modal-custom-text"
                                                defaultValue={
                                                    addDetails.term_day
                                                }
                                                onChange={(e) =>
                                                    handlePaymentChange(e)
                                                }
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-4 mb-2">
                                        <Col>
                                            <span className="edit-label">
                                                Payee
                                            </span>
                                            <Form.Control
                                                type="text"
                                                name="payee"
                                                className="nc-modal-custom-text"
                                                value={addDetails.payee}
                                                onChange={(e) => handlePaymentChange(e)}
                                            />
                                        </Col>
                                        <Col>
                                            <span className="edit-label">
                                                Particulars
                                            </span>
                                            <Form.Control
                                                type="text"
                                                name="particulars"
                                                className="nc-modal-custom-text"
                                                value={addDetails.particulars}
                                                onChange={(e) => handlePaymentChange(e)}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-4 mb-2">
                                        <Col>
                                            <span className="edit-label">
                                                Remarks
                                                <span className="edit-optional px-2">
                                                    (Optional)
                                                </span>
                                            </span>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Control
                                                as="textarea"
                                                name="payment_remarks"
                                                defaultValue={
                                                    addDetails.payment_remarks
                                                }
                                                className="nc-modal-custom-text"
                                                onChange={(e) =>
                                                    handlePaymentChange(e)
                                                }
                                            />
                                        </Col>
                                    </Row>
                                </>
                            )}
                        </>
                    )} */}

          {/* FOOTER: CANCEL & SUBMIT BUTTONS */}
          <div className="d-flex justify-content-end pt-5 pb-3">
            <button
              type="button"
              className="button-secondary me-3"
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>
            {isClicked ? (
              <div className="button-primary d-flex justify-content-center">
                <ReactLoading
                  type="bubbles"
                  color="#FFFFFF"
                  height={50}
                  width={50}
                />
              </div>
            ) : (
              <button
                type="button"
                className="button-primary"
                onClick={handleSubmit}
              >
                {edit ? "Save" : "Generate Invoice"}
              </button>
            )}
          </div>
        </div>
      </div>
      <Footer />
      <Modal
        open={preview}
        title={""}
        footer={null}
        onCancel={() => setPreview(false)}
      >
        <Row className="justify-content-center">
          <img
            alt="attachment"
            style={{
              width: "100%",
            }}
            src={previewFile}
          />
          <div className="mt-2 d-flex justify-content-center">
            <img
              src={trash}
              alt="trash"
              onClick={() => handleRemoveItemAttachment(previewFile)}
              className="cursor-pointer"
            />
          </div>
        </Row>
      </Modal>
      <FileExceedModal
        show={showFileExceedModal}
        onHide={() => setShowFileExceedModal(false)}
        size="2MB"
      />
    </div>
  )
}

export default SalesOrderForm
